import { render, staticRenderFns } from "./PublicRanking.vue?vue&type=template&id=b4c1e4b6"
import script from "./PublicRanking.vue?vue&type=script&lang=js"
export * from "./PublicRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports